import React from "react";
import "./BannerBreadcrumb.css";
const BannerBreadcrumb = (props) => {
    return (
        <>
            <div className="loan-eligibility-main">
                <div className="common-banner">
                    <h4 className="common-head">{props.head}</h4>
                    <p className="mb-0 common-parades">{props.parades}</p>
                </div>
            </div>
            <div className="custombreadcrumb">
                <a href="/">Home</a>&nbsp; /&nbsp;&nbsp; <span className="highlight">{props.pagename}</span>
            </div>
        </>
    )
}

export default BannerBreadcrumb;